import { Button, Input, Label, makeStyles } from "@fluentui/react-components";
import classNames from "classnames";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { handleInputCheck } from "../common/invalidCharCheck";
import { updateStation } from "../reducers/diningReducer";
import { stationSelector } from "../selectors/diningSelector";
import { useAppDispatch } from "../store/store";
import addItemStyles from "../styles/addItem.module.css";

/* ------------------ TYPES ------------------ */

type AddStationInputs = {
  updatedStationName: string;
};

/* ------------------ STYLES ------------------ */

const useStyles = makeStyles({
  container: {
    gap: "15px",
  },
  row: {
    display: "flex",
    alignItems: "flex-end",
    flexWrap: "wrap",
    gap: "10px",
  },
  grow: {
    flex: 1,
    width: "100%",
  },
  StationInput: {
    width: "100%",
  },
});

/* ------------------ COMPONENT ------------------ */

export const UpdateStation: React.FC = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const selectedStation = useSelector(stationSelector);
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
    watch,
  } = useForm<AddStationInputs>();
  const inputValue = watch("updatedStationName");
  const [invalidCharError, setInvalidCharError] = useState("");

  const onSubmit = (data: AddStationInputs) => {
    dispatch(updateStation(data.updatedStationName));
    reset({ updatedStationName: "" });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={classNames("menuContainer", classes.container)}>
        {/* Top Row */}
        <div className={classes.row}>
          {/* Input */}
          <div className={classes.grow}>
            <Label htmlFor="updatedStationName" style={{ fontWeight: "400" }}>
              Rename station
            </Label>
            <Input
              id="updatedStationName"
              className={classes.StationInput}
              placeholder={selectedStation?.name}
              aria-invalid={errors.updatedStationName ? "true" : "false"}
              {...register("updatedStationName", {
                required: { value: true, message: "This item needs a name." },
                minLength: { value: 3, message: "Can you be more descriptive?" },
                onChange: (e) => setInvalidCharError(handleInputCheck(e.target.value)),
              })}
            />

            {invalidCharError && <p className={addItemStyles.errorMessage}>{invalidCharError}</p>}
          </div>

          {/* Submit Button */}
          <Button appearance="primary" type="submit" disabled={inputValue == ""}>
            Update
          </Button>
        </div>

        {/* Validation Error */}
        {errors?.updatedStationName?.message && (
          <div role="alert" className={addItemStyles.errorMessage}>
            {errors?.updatedStationName?.message}
          </div>
        )}
      </div>
    </form>
  );
};
